'use strict';
import sxQuery from '../../sxQuery/sxQuery';
import SxQueryObject from '../../sxQuery/SxQueryObject';
import RebindStrategy from '../interface/RebindStrategy';
import EventHelper from './EventHelper';
import Helper from '../../siteSearch/utils/Helper';
var EVENT_TYPES = ['keydown', 'submit', 'click', 'focus', 'keyup', 'blur', 'keydown', 'beforeunload'];
var removeHiddenItems = function (nodeList) {
    if (nodeList === undefined) {
        return [];
    }
    var result = [];
    nodeList.forEach(function (node) {
        var isHidden = window.getComputedStyle(node).display === 'none';
        if (!isHidden) {
            result.push(node);
        }
    });
    return result;
};
var EventBinder = /** @class */ (function () {
    function EventBinder(tracker) {
        this.tracker = tracker;
        this.instanceId = "insights_".concat(Math.round(Math.random() * 100000));
        this.disableOnUnloadFlag = false;
        this.isSerpAbandonBound = false;
        this.isSerpClickBound = false;
        this.isSerpShownBound = false;
    }
    EventBinder.prototype.clearEvents = function (node) {
        var _this = this;
        EVENT_TYPES.forEach(function (e) {
            node.off("".concat(e, ".").concat(_this.instanceId));
        });
    };
    EventBinder.prototype.bindSearchBoxEvents = function (selector, searchButtonSelector, suggestBlockSelector, searchSuggestionSelector, activeSuggestionSelector, articleNumberSource, identifierSource, trackSubmitOnly, ignoreForms) {
        var _this = this;
        if (trackSubmitOnly === void 0) { trackSubmitOnly = false; }
        if (ignoreForms === void 0) { ignoreForms = false; }
        var $searchBox = sxQuery(selector);
        var $searchButton = sxQuery(searchButtonSelector);
        var $suggestBox = sxQuery(suggestBlockSelector).length > 0 ? sxQuery(sxQuery(suggestBlockSelector).get()[0]) : new SxQueryObject([]);
        this.clearEvents($searchBox);
        this.clearEvents($searchButton);
        // basic search box events
        var focusHandler = function (e) {
            // @ts-ignore
            _this.tracker.trackSearchBoxFocus(e.target);
        };
        var changeHandler = function (e) {
            // @ts-ignore
            _this.tracker.collectSearchBoxChange(e.target);
        };
        var blurHandler = function (e) {
            var suggestCount = searchSuggestionSelector ? $suggestBox.find(searchSuggestionSelector).length : undefined;
            // @ts-ignore
            _this.tracker.trackSearchBoxAbandon(sxQuery(e.target).val() || $searchBox.val(), suggestCount, e.target);
        };
        // search suggestion events
        var activeSuggestionCache = new SxQueryObject([]);
        var suggestSelectHandler = suggestBlockSelector ? function (e) {
            var selectedSuggestion = $suggestBox.find(activeSuggestionSelector);
            if (e.keyCode >= 37 && e.keyCode <= 40) {
                activeSuggestionCache = selectedSuggestion;
            }
            else if (e.keyCode !== 13) {
                activeSuggestionCache = new SxQueryObject([]);
            }
            if (e.keyCode === 13 && (activeSuggestionCache.length > 0 || selectedSuggestion.length > 0)) {
                selectedSuggestion = selectedSuggestion.length > 0 ? selectedSuggestion : activeSuggestionCache;
                var allSuggestions = $suggestBox.find(searchSuggestionSelector);
                var link = selectedSuggestion.find('a[href]').length > 0 ? selectedSuggestion.find('a[href]').attr('href') : selectedSuggestion.text();
                // @ts-ignore
                _this.tracker.trackSelectSuggest(e.target, sxQuery(suggestBlockSelector).get()[0], selectedSuggestion.get()[0], sxQuery(e.target).val() || $searchBox.val(), allSuggestions.length, Helper.getPositionInNodeList(allSuggestions.get(), selectedSuggestion.get()[0]), link, undefined, undefined, EventHelper.getDataSourceValue(articleNumberSource, selectedSuggestion.get()[0]), EventHelper.getDataSourceValue(identifierSource, selectedSuggestion.get()[0]));
            }
        } : undefined;
        // search submit events
        var submitHandler = function (e) {
            if (e.keyCode === 13) {
                // @ts-ignore
                _this.tracker.trackSubmitSearch(sxQuery(e.target).val() || $searchBox.val(), e.target, undefined, undefined);
            }
        };
        var searchButtonHandler = function (e) {
            // @ts-ignore
            _this.tracker.trackSubmitSearch($searchBox.val(), $searchBox.get()[0], e.target, undefined); // TODO: get closest input
        };
        var findParentForm = function (startNode) {
            // @ts-ignore
            var parentNode = startNode.parentNode;
            while (parentNode) {
                if (parentNode.tagName === 'FORM' && parentNode.getAttribute('action')) {
                    return parentNode;
                }
                // @ts-ignore
                parentNode = parentNode.parentNode;
            }
            return undefined;
        };
        document.querySelectorAll(selector).forEach(function (searchBox) {
            var form = ignoreForms ? undefined : findParentForm(searchBox);
            if (!form) { // no form found
                sxQuery(searchBox).on("keydown.".concat(_this.instanceId), submitHandler);
            }
            else {
                var $form = sxQuery(form);
                var formSubmitHandler = function () {
                    // @ts-ignore
                    _this.tracker.trackSubmitSearch(searchBox.value, searchBox, undefined, undefined); // we will simply ignore the search button in this case
                };
                _this.clearEvents($form);
                $form.on("submit.".concat(_this.instanceId), formSubmitHandler);
            }
        });
        document.querySelectorAll(searchButtonSelector).forEach(function (searchButton) {
            var form = ignoreForms ? undefined : findParentForm(searchButton);
            if (!form) {
                sxQuery(searchButton).on("click.".concat(_this.instanceId), searchButtonHandler);
            }
            else {
                // we assume that this is already bound by search box
            }
        });
        if (!trackSubmitOnly) {
            $searchBox.on("focus.".concat(this.instanceId), focusHandler);
            $searchBox.on("keyup.".concat(this.instanceId), changeHandler);
            $searchBox.on("blur.".concat(this.instanceId), blurHandler);
            if (suggestSelectHandler !== undefined) {
                $searchBox.on("keydown.".concat(this.instanceId), suggestSelectHandler);
            }
        }
    };
    EventBinder.prototype.bindSuggestBoxEvents = function (blockSelector, itemSelector, searchBoxSelector, articleNumberSource, identifierSource) {
        var _this = this;
        // TODO: now we asume only one search and suggestion box is available --> support multiple search boxes and suggestion boxes
        // @ts-ignore
        var suggestBox = document.querySelector(blockSelector);
        // @ts-ignore
        var searchBox = document.querySelector(searchBoxSelector);
        if (!suggestBox || !suggestBox.querySelector(itemSelector)) { // no suggest box or no items
            return;
        }
        var getQuery = function () {
            var searchBoxes = sxQuery(searchBoxSelector).get();
            for (var i = 0; i < searchBoxes.length; i++) {
                var $searchBox = sxQuery(searchBoxes[i]);
                if ($searchBox.val()) {
                    // @ts-ignore
                    return $searchBox.val();
                }
            }
            return undefined;
        };
        if (getComputedStyle(suggestBox).display !== 'none') {
            // @ts-ignore
            this.tracker.trackShowSuggests(searchBox, suggestBox, suggestBox.querySelector(itemSelector), getQuery(), suggestBox.querySelectorAll(itemSelector).length);
        }
        var trackLinksOnly = suggestBox.querySelector(itemSelector).querySelector('a') != null;
        var trackSelectCallback = function (selectedItem, selectedLink) {
            if (!selectedLink) {
                var firstLink = selectedItem.querySelector('a[href]');
                selectedLink = firstLink ? firstLink.getAttribute('href') : selectedItem.innerText;
            }
            var allItems = [].slice.call(suggestBox.querySelectorAll(itemSelector));
            var position = Helper.getPositionInNodeList(allItems, selectedItem);
            // @ts-ignore
            _this.tracker.trackSelectSuggest(searchBox, suggestBox, selectedItem, getQuery(), allItems.length, position, selectedLink, undefined, undefined, EventHelper.getDataSourceValue(articleNumberSource, selectedItem), EventHelper.getDataSourceValue(identifierSource, selectedItem));
        };
        var handler = trackLinksOnly ? function (e) {
            var $matchingParents = sxQuery(e.target).parents(blockSelector, true);
            if (e.target && $matchingParents.length > 0) {
                // @ts-ignore
                trackSelectCallback(e.target, sxQuery(e.target).attr('href'));
            }
        } : function (e) {
            // @ts-ignore
            trackSelectCallback(e.target);
        };
        var $targets = trackLinksOnly ? sxQuery(suggestBox).find(itemSelector).find('a') : sxQuery(suggestBox).find(itemSelector);
        this.clearEvents($targets);
        $targets.on("click.".concat(this.instanceId), handler);
    };
    EventBinder.prototype.bindSerpEvents = function (expectedConditions, querySource, resultBlockSelector, resultSelector, excludeSelector, groupSelector, articleNumberSource, identifierSource, unbindAbandonSelector, rebindStrategy) {
        var _this = this;
        if (rebindStrategy === void 0) { rebindStrategy = []; }
        // check context
        if (!EventHelper.matchesExpectedConditions(expectedConditions)) {
            return;
        }
        var query = EventHelper.getDataSourceValue(querySource);
        var $resultBlocks = sxQuery(resultBlockSelector);
        if (!$resultBlocks || $resultBlocks.length === 0) {
            return;
        }
        $resultBlocks.each(function (resultBlock) {
            var results = removeHiddenItems(resultBlock.querySelectorAll(resultSelector));
            if (!_this.isSerpShownBound || rebindStrategy.indexOf(RebindStrategy.Impression) !== -1) {
                _this.tracker.trackSerpShow(resultBlock, results.length > 0 ? results[0] : undefined, query, results.length, undefined, undefined);
                _this.isSerpShownBound = true;
            }
            var clickCallback = function (e, link) {
                _this.clearEvents(sxQuery(window));
                _this.disableOnUnloadFlag = true;
                var currentResults = removeHiddenItems(resultBlock.querySelectorAll(resultSelector));
                var position = Helper.getPositionInNodeList(currentResults, e.target);
                var positionInContentGroup = position;
                if (groupSelector !== undefined) {
                    var groups = [].slice.call(document.querySelectorAll(groupSelector));
                    for (var i = 0; i < groups.length; i++) {
                        var groupItems = removeHiddenItems(groups[i].querySelectorAll(resultSelector));
                        var inGroupPosition = Helper.getPositionInNodeList(groupItems, e.target);
                        if (inGroupPosition > -1) {
                            positionInContentGroup = inGroupPosition;
                            break;
                        }
                    }
                }
                if (link === undefined) {
                    // @ts-ignore
                    if (e.target.tagName === 'A') {
                        // @ts-ignore
                        link = e.target.getAttribute('href');
                    }
                    else {
                        // @ts-ignore
                        var firstAnchor = e.target.querySelector("a[href]".concat(excludeSelector ? ":not(".concat(excludeSelector, ")") : ''));
                        if (firstAnchor) {
                            link = firstAnchor.getAttribute('href');
                        }
                    }
                }
                _this.tracker.trackSerpClick(query, 
                // @ts-ignore
                e.target, resultBlock, currentResults.length, position, positionInContentGroup, link, undefined, 
                // @ts-ignore
                EventHelper.getDataSourceValue(articleNumberSource, e.target), 
                // @ts-ignore
                EventHelper.getDataSourceValue(identifierSource, e.target));
            };
            if (!_this.isSerpClickBound || rebindStrategy.indexOf(RebindStrategy.Click) !== -1) {
                var activeSelector_1 = "a[href]".concat(excludeSelector ? ":not(".concat(excludeSelector, ")") : '');
                _this.clearEvents(sxQuery(activeSelector_1));
                _this.clearEvents(sxQuery(resultBlock).find(resultSelector));
                results.forEach(function (result) {
                    // @ts-ignore
                    var anchors = result.tagName === 'A' ? [] : [].slice.call(result.querySelectorAll(activeSelector_1));
                    if (anchors.length === 0) {
                        sxQuery(result).on("click.".concat(_this.instanceId), function () {
                            // @ts-ignore
                            clickCallback({ target: result }, undefined);
                        });
                    }
                    else {
                        anchors.forEach(function (anchor) {
                            sxQuery(anchor).on("click.".concat(_this.instanceId), function () {
                                // @ts-ignore
                                clickCallback({ target: result }, anchor.getAttribute('href'));
                            });
                        });
                    }
                });
            }
        });
        this.isSerpClickBound = true;
        if (!this.isSerpAbandonBound || rebindStrategy.indexOf(RebindStrategy.Abandon) !== -1) {
            this.clearEvents(sxQuery(window));
            var beforeUnload = function () {
                var resultBlock = removeHiddenItems($resultBlocks.get())[0];
                var currentItems = removeHiddenItems([].slice.call(resultBlock.querySelectorAll(resultSelector)));
                if (!_this.disableOnUnloadFlag) {
                    _this.tracker.trackSerpLeave(resultBlock, currentItems && currentItems.length > 0 ? currentItems[0] : undefined, query, currentItems.length, undefined);
                }
            };
            if (!this.disableOnUnloadFlag) {
                sxQuery(window).on("beforeunload.".concat(this.instanceId), beforeUnload);
            }
        }
        if (unbindAbandonSelector !== undefined) {
            sxQuery(resultBlockSelector).find(resultSelector).find(unbindAbandonSelector).each(function (node) {
                var $node = sxQuery(node);
                var handler = function () {
                    sxQuery(window).off("beforeunload.".concat(_this.instanceId));
                };
                if (node.tagName === 'FORM') {
                    $node.on('submit', handler);
                }
                else {
                    $node.on('click', handler);
                }
            });
        }
    };
    EventBinder.prototype.bindCartEvents = function (config) {
        var _this = this;
        // check context
        if (!EventHelper.matchesExpectedConditions(config.expectedConditions)) {
            return;
        }
        var $trigger = sxQuery(config.trigger);
        this.clearEvents($trigger);
        var eventName = "click.".concat(this.instanceId);
        if ($trigger.length > 0 && $trigger.get()[0].tagName === 'FORM') {
            eventName = "submit.".concat(this.instanceId);
        }
        $trigger.on(eventName, function () {
            var wrapper = config.wrapper !== undefined ? document.querySelector(config.wrapper) : undefined;
            var articleNumber = EventHelper.getDataSourceValue(config.articleNumberSource, wrapper);
            if (articleNumber !== undefined && articleNumber !== null) {
                articleNumber = articleNumber.toString().trim();
            }
            var identifier = EventHelper.getDataSourceValue(config.identifierSource, wrapper);
            var link = config.linkSource ? EventHelper.getDataSourceValue(config.linkSource, wrapper) : window.location.href;
            var countValue = EventHelper.getDataSourceValue(config.countSource, wrapper);
            var count = countValue ? parseInt(countValue, 10) : 1;
            var priceValue = EventHelper.getDataSourceValue(config.priceSource, wrapper);
            var price = parseFloat(priceValue);
            if (Helper.isNaN(price)) {
                price = parseFloat(priceValue.replace(/,/g, '.'));
            }
            if (Helper.isNaN(price)) {
                price = undefined;
            }
            var priceUnit = EventHelper.getDataSourceValue(config.priceUnitSource, wrapper);
            _this.tracker.trackAddToCart(articleNumber, identifier, link, count, price, priceUnit);
        });
    };
    EventBinder.prototype.bindCheckoutEvents = function (config) {
        var _this = this;
        // check context
        if (!EventHelper.matchesExpectedConditions(config.expectedConditions)) {
            return;
        }
        var trackCheckout = function () {
            var data = [];
            if (config.getter !== undefined) {
                data = config.getter();
            }
            else if (config.itemSource !== undefined) {
                var itemSource_1 = config.itemSource;
                var $entries = sxQuery(itemSource_1.selector);
                $entries.get().forEach(function (entry) {
                    var countValue = EventHelper.getDataSourceValue(itemSource_1.countSource, entry);
                    var count = countValue ? parseInt(countValue, 10) : 1;
                    var priceValue = EventHelper.getDataSourceValue(itemSource_1.unitPriceSource, entry);
                    var unitPrice = parseFloat(priceValue);
                    if (Helper.isNaN(unitPrice)) {
                        unitPrice = parseFloat(priceValue.replace(/,/g, '.'));
                    }
                    if (Helper.isNaN(unitPrice)) {
                        unitPrice = undefined;
                    }
                    var articleNumber = EventHelper.getDataSourceValue(itemSource_1.articleNumberSource, entry);
                    if (articleNumber !== undefined && articleNumber !== null) {
                        articleNumber = articleNumber.toString().trim();
                    }
                    data.push({
                        articleNumber: articleNumber,
                        link: EventHelper.getDataSourceValue(itemSource_1.linkSource, entry),
                        identifier: EventHelper.getDataSourceValue(itemSource_1.identifierSource, entry),
                        unitPrice: unitPrice,
                        priceUnit: EventHelper.getDataSourceValue(itemSource_1.priceUnitSource, entry),
                        count: count
                    });
                });
            }
            else if (config.itemObject !== undefined) {
                var itemObject_1 = config.itemObject;
                try {
                    //  @ts-ignore
                    var arr = itemObject_1.selector !== undefined ? JSON.parse(document.querySelector(itemObject_1.selector).innerText) : window[itemObject_1.windowProperty];
                    arr.forEach(function (obj) {
                        var countValue = EventHelper.resolveJPath(obj, itemObject_1.countJPath);
                        var count = countValue ? parseInt(countValue, 10) : 1;
                        var priceValue = EventHelper.resolveJPath(obj, itemObject_1.unitPriceJPath);
                        var unitPrice = parseFloat(priceValue);
                        if (Helper.isNaN(unitPrice)) {
                            unitPrice = parseFloat(priceValue.replace(/,/g, '.'));
                        }
                        if (Helper.isNaN(unitPrice)) {
                            unitPrice = undefined;
                        }
                        var articleNumber = EventHelper.resolveJPath(obj, itemObject_1.articleNumberJPath);
                        if (articleNumber !== undefined && articleNumber !== null) {
                            articleNumber = articleNumber.toString().trim();
                        }
                        data.push({
                            articleNumber: articleNumber,
                            link: EventHelper.resolveJPath(obj, itemObject_1.linkJPath),
                            identifier: EventHelper.resolveJPath(obj, itemObject_1.identifierJPath),
                            unitPrice: unitPrice,
                            priceUnit: EventHelper.resolveJPath(obj, itemObject_1.priceUnitJPath),
                            count: count
                        });
                    });
                }
                catch (err) {
                    console.error(err);
                }
            }
            _this.tracker.trackBuy(data, config.trackAll !== undefined ? config.trackAll : false);
        };
        if (config.trigger === 'pageload') {
            trackCheckout();
        }
        else {
            var lastTriggerNode_1;
            var bind_1 = function () {
                var $trigger = sxQuery(config.trigger);
                lastTriggerNode_1 = $trigger.get(0);
                _this.clearEvents($trigger);
                var eventName = "click.".concat(_this.instanceId);
                if ($trigger.length > 0 && $trigger.get()[0].tagName === 'FORM') {
                    eventName = "submit.".concat(_this.instanceId);
                }
                $trigger.on(eventName, function () {
                    trackCheckout();
                    _this.clearEvents($trigger);
                });
            };
            bind_1();
            if (config._triggerCanChange) {
                setInterval(function () {
                    var $trigger = sxQuery(config.trigger);
                    if (lastTriggerNode_1 !== $trigger.get(0)) {
                        bind_1();
                    }
                }, 500);
            }
        }
    };
    EventBinder.prototype.unbindAll = function () {
        this.clearEvents(sxQuery('*'));
    };
    return EventBinder;
}());
export default EventBinder;
